'use client'

import { ReactNode, useContext } from 'react'
import { useStore } from 'zustand'
import { StoreContext } from '@/app/_providers/StoreProvider'
import s from './DebugPanel.module.css'

const replacer = (_key: string, value: unknown): unknown => {
  if (value instanceof Set) return [...value]
  if (value instanceof Map) return Object.fromEntries(value)
  if (value instanceof Date) return value.toISOString()
  return value
}

const StoreDebug = (): ReactNode => {
  const store = useContext(StoreContext)
  const state = useStore(store!, (st) => st)

  return (
    <details className={s.panel} aria-label="Store debug panel">
      <summary className={s.summary}>
        <span className={s.summaryIcon} aria-hidden="true">&#9654;</span>
        <span className={s.summaryTitle}>Zustand Store (raw)</span>
        <span className={`${s.summaryBadge} ${s.summaryBadgeOk}`}>
          {Object.keys(state).length}
          {' '}
          keys
        </span>
      </summary>
      <pre className={s.rawPre}>
        {JSON.stringify(state, replacer, 2)}
      </pre>
    </details>
  )
}

export default StoreDebug
